import { Action } from '@ngrx/store';
import * as models from '../../domain/models';
import * as viewModels from '../../view/view-models';

export const LOAD = '[RM Market Detail] Load';
export const LOAD_SUCCESS = '[RM Market Detail] Load Success';
export const LOAD_FAIL = '[RM Market Detail] Load Fail';
export const UPDATE = '[RM Market Detail] Update';
export const SAVE = '[RM Market Detail] Save';
export const SAVE_SUCCESS = '[RM Market Detail] Save Success';
export const SAVE_FAIL = '[RM Market Detail] Save Fail';

export class LoadPayload {
  constructor(public id: string) {}
}

export class LoadAction implements Action {
  readonly type = LOAD;

  constructor(public payload: LoadPayload) {}
}

export class LoadSuccessPayload {
  constructor(public item: models.Market) {}
}

export class LoadSuccessAction implements Action {
  readonly type = LOAD_SUCCESS;

  constructor(public payload: LoadSuccessPayload) {}
}

export class LoadFailAction implements Action {
  readonly type = LOAD_FAIL;
}

export class UpdatePayload {
  constructor(public item: models.Market) {}
}

export class UpdateAction implements Action {
  readonly type = UPDATE;

  constructor(public payload: UpdatePayload) {}
}

export class SaveAction implements Action {
  readonly type = SAVE;
}

export class SaveSuccessPayload {
  constructor(public item: models.Market) {}
}

export class SaveSuccessAction implements Action {
  readonly type = SAVE_SUCCESS;

  constructor(public payload: SaveSuccessPayload) {}
}

export class SaveFailAction implements Action {
  readonly type = SAVE_FAIL;
}

export type Actions =
  | LoadAction
  | LoadSuccessAction
  | LoadFailAction
  | UpdateAction
  | SaveAction
  | SaveSuccessAction
  | SaveFailAction;
